import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { useShopSettings } from "@/context/ShopSettingsContext";

export default function AdminSettings() {
  const s = useShopSettings();
  const [showcase, setShowcase] = useState(s.showcase_mode);
  const [url, setUrl] = useState(s.tiktok_shop_url);
  const [saving, setSaving] = useState(false);

  useEffect(() => { setShowcase(s.showcase_mode); setUrl(s.tiktok_shop_url); }, [s.showcase_mode, s.tiktok_shop_url]);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/settings", { showcase_mode: showcase, tiktok_shop_url: url.trim() });
      await s.reload();
      toast.success(showcase ? "Modalità vetrina attiva: vendite sospese" : "Vendite online riattivate");
    } catch (e) {
      toast.error(errMsg(e, "Inserisci un link https valido"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="card-mc max-w-2xl space-y-5 p-5">
      <label className="flex items-start justify-between gap-4">
        <div>
          <div className="font-display text-lg font-extrabold">Modalità vetrina</div>
          <p className="text-sm text-muted-foreground">
            Nasconde prezzi, carrello e cassa ai clienti e blocca i pagamenti. Al posto dell'acquisto compare "Acquista su TikTok Shop".
          </p>
        </div>
        <Switch data-testid="admin-showcase-switch" checked={showcase} onCheckedChange={setShowcase} />
      </label>
      <div className="space-y-1.5">
        <div className="text-xs font-bold uppercase tracking-wider text-muted-foreground">Link TikTok Shop (generico)</div>
        <Input data-testid="admin-tiktok-url-input" value={url} onChange={(e) => setUrl(e.target.value)} className="h-11" placeholder="https://www.tiktok.com/@..." />
        <p className="text-xs text-muted-foreground">Usato quando un articolo non ha un proprio link TikTok.</p>
      </div>
      <button data-testid="admin-settings-save" className="btn-mc" onClick={save} disabled={saving}>
        {saving ? "Salvataggio…" : "Salva"}
      </button>
    </div>
  );
}
